/** Import text for review, never HTML or an image advertised as editable prose. */
export async function readTermsFile(file:File):Promise<string> {
  if(file.size>25*1024*1024)throw new Error('signing.digital.importTooLarge');
  const bytes=new Uint8Array(await file.arrayBuffer());
  let text='';
  if(/\.txt$/i.test(file.name)||file.type==='text/plain') {
    try{text=new TextDecoder('utf-8',{fatal:true}).decode(bytes);}catch{throw new Error('signing.digital.importTermsFailed');}
    if(text.includes('\0'))throw new Error('signing.digital.importTermsFailed');
  }else if(/\.pdf$/i.test(file.name)||file.type==='application/pdf') {
    const [{getDocument,PDFWorker},{default:Worker}]=await Promise.all([import('pdfjs-dist/legacy/build/pdf.mjs'),import('pdfjs-dist/legacy/build/pdf.worker.min.mjs?worker')]);
    const port=new Worker();const worker=PDFWorker.create({port});
    const task=getDocument({data:bytes,worker});
    try{
      text=await extractTermsPdfText(await task.promise);
    }finally{await task.destroy();worker.destroy();port.terminate();}
  }else throw new Error('signing.digital.importTermsFailed');
  text=text.replace(/\r\n?/g,'\n').trim();
  if(!text)throw new Error('signing.digital.importNoText');if(text.length>49_000)throw new Error('signing.digital.importTooLarge');
  return text;
}
import type {PDFDocumentProxy} from 'pdfjs-dist';

export async function extractTermsPdfText(pdf:Pick<PDFDocumentProxy,'numPages'|'getPage'>):Promise<string> {
  if(pdf.numPages>80)throw new Error('signing.digital.importTooLarge');
  const pages:string[]=[];let length=0;
  for(let number=1;number<=pdf.numPages;number++){
    const page=await pdf.getPage(number);
    try{
      const content=await page.getTextContent();
      const prose=content.items.map(item=>'str'in item?`${item.str}${item.hasEOL?'\n':' '}`:'').join('').trim();
      if(!prose)throw new Error('signing.digital.importNoText');pages.push(prose);length+=prose.length+2;
      if(length>49_000)throw new Error('signing.digital.importTooLarge');
    }finally{page.cleanup();}
  }
  return pages.join('\n\n');
}
